import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogUnblockDealerBlacklistData {
  title?: string;
  description?: string;
  confirmText?: string;
  minLength?: number;
  maxLength?: number;
  initialReason?: string;
}

@Component({
  selector: 'app-dialog-unblock-dealer-blacklist',
  templateUrl: './dialog-unblock-dealer-blacklist.component.html',
  styleUrls: ['./dialog-unblock-dealer-blacklist.component.scss'],
})
export class DialogUnblockDealerBlacklistComponent implements OnInit {
  reason = '';

  title = 'DESBLOQUEAR COMPRADOR';
  description = 'Por favor, informe o motivo do desbloqueio do comprador:';
  confirmText = 'DESBLOQUEAR';
  minLength = 5;
  maxLength = 150;

  constructor(
    private dialogRef: MatDialogRef<DialogUnblockDealerBlacklistComponent, string>,
    @Inject(MAT_DIALOG_DATA) data: DialogUnblockDealerBlacklistData
  ) {
    if (data?.title) {
      this.title = data.title;
    }
    if (data?.description) {
      this.description = data.description;
    }
    if (data?.confirmText) {
      this.confirmText = data.confirmText;
    }
    if (data?.minLength) {
      this.minLength = data.minLength;
    }
    if (data?.maxLength) {
      this.maxLength = data.maxLength;
    }
    if (data?.initialReason) {
      this.reason = data.initialReason;
    }
  }

  ngOnInit(): void {
    this.dialogRef.disableClose = false;
  }

  get canConfirm(): boolean {
    return this.reason.trim().length >= this.minLength;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (!this.canConfirm) {
      return;
    }

    this.dialogRef.close(this.reason.trim());
  }
}
